import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import ShowContainer from '../../shared/components/show/ShowContainer';
import FormWrapper from '../../shared/components/form/FormWrapper';

class Form extends Component {
  handleValidate = (values) => {
    const errors = {};
    if (!values.id) errors.id = 'Required';
    return errors;
  }

  render() {
    return (
      <Container>
        <ShowContainer>
          {
            ({ id }) => {
              if (!id) return null;
              const initialValues = { id };

              return (
                <FormWrapper
                  initialValues={initialValues}
                  onValidate={this.handleValidate}
                  formUrlSuffix={`/${id}/mark_as_tested`}
                  formTitle="Confirm Mark As Tested"
                  formSubTitle={`Please confirm that you would like to mark Kit #${id} as Tested`}
                  successModalTitle="Kit Marked as Tested!"
                  successModalMessage="You will be redirected back to the Kits index"
                  submitButtonText="Confirm Mark as Tested"
                  successUrl="/inventory/kits"
                />
              );
            }
          }
        </ShowContainer>
      </Container>
    );
  }
}

export default withRouter(connect()(Form));
